import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { ManageFootballSubTeam } from "../../../../../../commons/models/football/admin/manage-football-sub-team";
import { PaginatedEnsueCollection } from "../../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import {QueryParamOptions} from "../../../../../../commons/types/query-param-options";

export interface ISubTeamListOptions {
  teamId: number;
  urlParams?: QueryParamOptions;
}
export interface IManageTeamListState {
  subTeamList: PaginatedEnsueCollection<ManageFootballSubTeam>;
  subTeamListStatus: StatusEnum;
}

const initialState: IManageTeamListState = {
  subTeamList: new PaginatedEnsueCollection<ManageFootballSubTeam>(),
  subTeamListStatus: StatusEnum.Idle,
};

export const fetchManageSubTeamList = createAsyncThunk(
  "manage/subTeamList",
  async (options: ISubTeamListOptions, thunkAPI) => {
    try {
      const subTeamList = await manageFootballTeamService.getSubTeams(options.teamId, {
        ...options.urlParams,
      });
      return subTeamList as PaginatedEnsueCollection<ManageFootballSubTeam>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageSubTeamListSlice = createSlice({
  name: "footballManageTeamList",
  initialState: initialState,
  reducers: {
    cleanUpSubTeamList(state) {
      state.subTeamList = new PaginatedEnsueCollection<ManageFootballSubTeam>();
      state.subTeamListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSubTeamList.pending, (state) => {
        state.subTeamListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageSubTeamList.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<ManageFootballSubTeam>>) => {
          state.subTeamListStatus = StatusEnum.Succeeded;
          state.subTeamList = action.payload;
        }
      )
      .addCase(fetchManageSubTeamList.rejected, (state) => {
        state.subTeamListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSubTeamList } = footballManageSubTeamListSlice.actions;
export default footballManageSubTeamListSlice.reducer;
